export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive wordpress',
  features: {},
  show_category_in_selected_filters: true
}
